import React from 'react';

const JobDescriptionSection = ({ jobData, handleInputChange, errors }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">Job Description</h3>
      
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Description *
        </label>
        <textarea
          name="description"
          value={jobData.description}
          onChange={handleInputChange}
          rows={6}
          className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="Provide a detailed description of the role, company, and what makes this position attractive..."
        />
        {errors.description && <p className="text-red-600 text-sm mt-1">{errors.description}</p>}
      </div>
    </div>
  );
};

export default JobDescriptionSection;